exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".contact .map[data-v-6cdc49f0]{margin-bottom:70px}.contact .map iframe[data-v-6cdc49f0]{width:100%;height:250px;border:1px solid #ccc!important}.contact form .input-field[data-v-6cdc49f0]{margin-bottom:30px}.contact form .input-field label[data-v-6cdc49f0]{font:700 1.6rem Roboto,sans-serif;top:-15px}.contact form .input-field textarea[data-v-6cdc49f0]{height:100px!important}.contact form .btn[data-v-6cdc49f0]{height:42px;line-height:42px;border-radius:21px;box-shadow:0 0 0 transparent;background-color:#f2f2f2;color:#2d2d2d;border:1px solid #ccc}.contact form .btn[data-v-6cdc49f0]:hover{background-color:#e2e2e2}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6cdc49f0","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Contact.vue
// module id = 65
// module chunks = 0